import script from "./GoogleFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleFiles.vue?vue&type=script&setup=true&lang=js"

import "./GoogleFiles.vue?vue&type=style&index=0&id=ad63857e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad63857e"]])

export default __exports__